// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"fd782923","376":"057c64b2","648":"954d4946","740":"e66f2ab4"}[chunkId] + ".chunk.js";
};